<template>
    <div class="body">
        <el-row>
            <el-col :span="6" v-for="(item, index) in cardList" :key="index" :offset="index > 0 ? 0 : 0">
                <el-card class="card" :body-style="{ padding: '0px' }">
                <img :src="item.productCover" class="image">
                <div style="padding: 14px;">
                    <span>{{item.productName}}</span>
                    <div class="bottom clearfix">
                    <p class="time">商品消耗:{{item.leg}}颗金豆、{{item.coupon}}面额优惠券</p>
                    <p class="number">总数量:<span class="price">{{item.number}}</span>、总金额:<span class="price">{{item.amoutPrice}}</span>$</p>
                    </div>
                </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('product')
export default {
    data(){
        return{
            currentDate: new Date(),
            cardList:[]
        }
    },
    mounted(){
        this.home();
    },
    computed:{
      ...mapState({
         orderId:state=>state.orderId
      })
    },
    methods:{
        home(){
            this.joker.store.orderSlide(this.orderId).then(res=>{
                console.log(res.content.vos)
                this.cardList = res.content.vos
            })
        }
    }
}
</script>

<style scoped>

.time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }

  .card{
      margin-left: 5%;
  }

 .number{
    margin-top: 5%;
    font-size: 15px;
 }
  .price{
     color: red;
  }

</style>


// WEBPACK FOOTER //
// src/components/Store/Order/OrderSlide.vue